<div class="text-center pt-4 pb-7">
  <p>Restaurant.pe debe atender el reclamo en plazo de 30 días hábiles.
    "Estimado usuario: Usted puede presentar su queja cuando no le hayan brindado un servicio, prestación o cobertura solicitada, o recibida de Restaurant.pe"
    </p>
</div>
